import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone } from 'lucide-react';
import {
  FOOTER_NAV_ITEMS,
  CUSTOMER_SERVICE_ITEMS,
  SOCIAL_LINKS,
  CONTACT_INFO,
} from '@shared/constants/navigation';

const socialIcons = {
  instagram: Instagram,
  facebook: Facebook,
} as const;

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-carbon text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="mb-4 flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-mauve text-white font-bold">
                R
              </div>
              <span className="font-heading text-xl">Reconócete</span>
            </div>
            <p className="mb-4 max-w-md text-gray-300">
              Tienda especializada en regalos personalizados únicos. Encuentra
              el regalo perfecto para expresar tu personalidad.
            </p>
            <div className="flex gap-4">
              {SOCIAL_LINKS.map((link) => {
                const IconComponent = socialIcons[link.platform];
                return (
                  <a
                    key={link.platform}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={link.ariaLabel}
                    className="text-gray-300 hover:text-brand-mauve transition-colors"
                  >
                    <IconComponent className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Navigation Section */}
          <div>
            <h3 className="mb-4 font-semibold">Navegación</h3>
            <ul className="space-y-2 text-gray-300">
              {FOOTER_NAV_ITEMS.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="hover:text-brand-mauve transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Service Section */}
          <div>
            <h3 className="mb-4 font-semibold">Atención al Cliente</h3>
            <ul className="space-y-2 text-gray-300">
              {CUSTOMER_SERVICE_ITEMS.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="hover:text-brand-mauve transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="mb-4 font-semibold">Contacto</h3>
            <ul className="space-y-3 text-gray-300">
              <li>
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="flex items-center gap-2 hover:text-brand-mauve transition-colors"
                >
                  <Mail className="h-4 w-4" />
                  <span>{CONTACT_INFO.email}</span>
                </a>
              </li>
              <li>
                <span className="flex items-center gap-2">
                  <Phone className="h-4 w-4" />
                  <span>{CONTACT_INFO.phone}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 border-t border-gray-700 pt-8 text-center text-gray-300 text-sm">
          <p>&copy; {currentYear} Reconócete. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
